import { createElement } from 'react';
import i18next from 'i18n';

import Trans from 'components/Common/Translation/Trans';
import useCurrentCountry from 'hooks/useCurrentCountry';
import { genderOptions, genderOptionsUk } from 'model/CommonFields';
import { Field } from 'settings/fields/field';
import { AC } from 'settings/form';

const { isFr, isUk } = useCurrentCountry();

export const customerFields: Field[] = [
  {
    name: 'civility',
    label: i18next.t('LABEL_TITLE_GENDER'),
    type: 'radio',
    options: isUk ? genderOptionsUk : genderOptions,
    required: true,
  },
  {
    name: 'lastName',
    label: i18next.t('LABEL_SURNAME'),
    required: true,
    autoComplete: AC.LastName,
  },
  {
    name: 'firstName',
    label: i18next.t('LABEL_FIRST_NAME'),
    required: true,
    autoComplete: AC.FirstName,
  },
  {
    name: 'email',
    label: i18next.t('LABEL_EMAIL_ADDRESS'),
    required: true,
    autoComplete: AC.Email,
  },
  {
    name: 'nameWay',
    label: i18next.t('LABEL_NAME_WAY'),
    required: true,
    autoComplete: AC.StreetAddress,
  },
  isFr && {
    name: 'nameComplement',
    label: i18next.t('LABEL_BUILDING_COMPLEMENT'),
    autoComplete: AC.Off,
  },
  {
    name: 'nameAddress',
    label: i18next.t('LABEL_BUILDING'),
    autoComplete: AC.Off,
  },
  {
    name: 'locality',
    label: i18next.t('LABEL_LOCALITY'),
    autoComplete: AC.Off,
  },
  {
    name: 'postCode',
    label: i18next.t('LABEL_POSTCODE'),
    required: true,
    autoComplete: AC.PostalCode,
    validation: isFr ? 'number' : undefined,
  },
  {
    name: 'city',
    label: i18next.t('LABEL_CITY'),
    required: true,
    validation: 'letter',
    autoComplete: AC.City,
  },
  {
    name: 'country',
    label: i18next.t('LABEL_COUNTRY'),
    required: true,
    disabled: true,
    autoComplete: AC.Country,
  },
  {
    name: 'landLine',
    label: i18next.t('LABEL_LANDLINE'),
    validation: 'number',
    autoComplete: AC.Landline,
  },
].filter(Boolean) as Field[];

export const customerDetailsFields = [
  {
    name: 'customerNumber',
    label: createElement(Trans, {
      i18nKey: 'LABEL_CUSTOMER_NUMBER',
      namespace: 'contactPage',
    }),
  },
  {
    name: 'orderNumber',
    label: i18next.t('LABEL_ORDER_NUMBER_ORDER', { ns: 'contactPage' }),
  },
];

export const formSubjects = [
  {
    disabled: true,
    label: i18next.t('LABEL_REQUEST_CONCERNS', { ns: 'contactPage' }),
    value: '',
  },
  {
    label: i18next.t('LABEL_ORDER_PRODUCTS', { ns: 'contactPage' }),
    value: 'orderProducts',
  },
  {
    label: i18next.t('LABEL_GIFTS_GAMES', { ns: 'contactPage' }),
    value: 'giftsGames',
  },
  {
    label: i18next.t('LABEL_WEBSITE', { ns: 'contactPage' }),
    value: 'website',
  },
  {
    label: i18next.t('LABEL_OTHER_SUBJECT', { ns: 'contactPage' }),
    value: 'otherSubject',
  },
];
